import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["href", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useDeviceInfoQuery } from "@/hooks";
import config from "@/lib/config";
import maybeIOS from "@/lib/maybeIOS";
import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback, useMemo } from "react";
/**
 * WebView時にdeeplinkに書き換えるページをここで指定する。webのpath: アプリのpath
 * @type {Object.<string, string>}
 */

import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var pathsDictionary = {
  watch: "watch",
  title: "titles"
};
/**
 *WebViewで表示時、受け取ったhrefがpathsDictionaryにマッチした場合、deeplinkに書き換える。deeplinkの書き換えはページ名/[id]の形式のページに対してのみ動作する。
 *@param {Object} props
 *@param {String} props.href - ページのpath
 *@param {React.element} props.children - このコンポーネントで括った親コンポーネントのDOM
 *@param {Object} ...props - その他props
 *@returns {React.element}
 */

function VersatileLink(_ref) {
  var href = _ref.href,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useDeviceInfoQuery = useDeviceInfoQuery(),
      _useDeviceInfoQuery$d = _useDeviceInfoQuery.data;

  _useDeviceInfoQuery$d = _useDeviceInfoQuery$d === void 0 ? {} : _useDeviceInfoQuery$d;
  var deviceInfo = _useDeviceInfoQuery$d.deviceInfo;
  var router = useRouter();
  var judgedLink = useMemo(function () {
    var _ref2 = deviceInfo !== null && deviceInfo !== void 0 ? deviceInfo : {},
        isWebView = _ref2.isWebView,
        isAndroid = _ref2.isAndroid;

    var isIOS = maybeIOS(deviceInfo);
    var pathsArr = Object.keys(pathsDictionary);
    var pathsStr = pathsArr.join("|");
    var regex = new RegExp("^/?(?<path>".concat(pathsStr, ")/(?<id>\\d+)"));
    var matched = href.match(regex);

    if (matched && isWebView) {
      var _matched$groups = matched.groups,
          path = _matched$groups.path,
          id = _matched$groups.id;

      if (isIOS) {
        return "spoox://".concat(pathsDictionary[path], "/").concat(id);
      }

      if (isAndroid) {
        return "intent://".concat(pathsDictionary[path], "/").concat(id, "#Intent;scheme=spoox;package=").concat(config.androidPackageName, ";end");
      }
    } else {
      return href;
    }
  }, [deviceInfo, href]);
  var isWatchPageFlag = router.asPath.includes("/watch") && href.includes("/watch") && !judgedLink.includes("spoox://") && !judgedLink.includes("intent://") || false;
  var handleWatchPageClick = useCallback(function () {
    window.location.replace(judgedLink);
  }, [judgedLink]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!isWatchPageFlag && /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, props), {}, {
      href: judgedLink,
      children: children
    })), isWatchPageFlag && /*#__PURE__*/_jsx("a", {
      onClick: handleWatchPageClick,
      children: children
    })]
  });
}

export default VersatileLink;